<template>
  <router-link v-slot="linkProps" custom :to="to" :replace="replace">
    <a
      :class="[
        $attrs.class,
        {
          [inactiveClass]: !linkProps.isActive && !pathMatch,
          [activeClass]: linkProps.isActive || pathMatch,
          [exactActiveClass]: linkProps.isExactActive,
          [pathActiveClass]: pathMatch && linkProps.isActive,
        },
      ]"
      :href="linkProps.href"
      :target="target"
      @click="linkProps.navigate"
    >
      <slot v-bind="linkProps" />
    </a>
  </router-link>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import type { MRouterLinkProps } from '.';

  const props = withDefaults(defineProps<MRouterLinkProps>(), {
    inactiveClass: 'inactive',
    activeClass: 'active',
    pathRegex: null,
    target: undefined,
    replace: false,
    exactActiveClass: 'active',
    pathActiveClass: 'active',
  });

  const currentRoute = useRoute();

  const pathMatch = computed(() => {
    if (!props.pathRegex) return false;
    let r = props.pathRegex;
    if (typeof r === 'string') r = new RegExp(props.pathRegex);
    const match = currentRoute.path.match(r);
    return match !== null && match.length > 0;
  });
</script>
